import { createSlice } from '@reduxjs/toolkit';

import { COUNTRY_FLAGS, COUNTRY_PHONE_CODES } from '@/constants/countryCodes';

import { Tenant } from '@/types/common';
import { Option } from '@/types/components/common';
import { Territory } from '@/types/places';

import { fetchTerritories } from './actions';

interface TerritoryDataState {
  territories: Territory[];
  territoryByCountryCode: Record<Territory['countryCode'], Territory>;
  phoneCodes: Option[];
}

const INITIAL_COUNTRIES_STATE: TerritoryDataState = {
  territories: [],
  territoryByCountryCode: {},
  phoneCodes: [],
};

export const territoryDataSlice = createSlice({
  name: 'territory-data',
  initialState: INITIAL_COUNTRIES_STATE,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchTerritories.fulfilled, (state, { payload }) => {
      state.territories = payload;

      state.territoryByCountryCode = payload.reduce(
        (acc, item) => ({
          ...acc,
          [item.countryCode]: item,
        }),
        {},
      );

      state.phoneCodes = payload.map(
        territory =>
          ({
            value:
              COUNTRY_PHONE_CODES[territory.tenant.toLowerCase() as Tenant],

            text: `+${COUNTRY_PHONE_CODES[territory.tenant.toLowerCase() as Tenant]}`,
            icon: COUNTRY_FLAGS[territory.tenant.toLowerCase() as Tenant],
          }) as Option,
      );
    });
  },
});

export const territoryDataReducer = territoryDataSlice.reducer;
